<template>
	<div class="home">
		<top :p="0"></top>
		
		<lbt></lbt>
		
		<left></left>
		
		<div class="dibu">
			<bar></bar>
		</div>
	</div>
</template>

<script>
	// @ is an alias to /src
	import top from "../components/top.vue"
	import bar from "../components/bar.vue"
	import lbt from "../components/lbt.vue"
	import left from "../components/left.vue"
	
	export default {
		name: 'HomeView',
		components: {
			top,
			bar,
			lbt,
			left
		},
		data() {
			return {
				
			}
		},
	}
</script>

<style scoped lang="less">
	.home {
		width: 100vw;
		height: 100vh;
		position: relative;
		overflow: hidden;
	}
	
	.dibu{
		position: absolute;
		bottom: 0;
		left: 0;
		z-index: 99;
	}
	
</style>